import React from 'react';
import '../template-file-css/document-file-template.css';
// import { AddGoalsUsingPatientList } from '../common-controlls/rendergoals-using-client';
// import { AddDxUsingPatientList } from '../common-controlls/renderdiagnosis-using-client';


export const GENERAL_StaffPlanDocument = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_StaffPlanDocument' className='file-pdf-document'>
            <div className='file-template'> 

 

            <p className='w-750'>
                    <span className='eleHeader'>Training Needs:</span> 
                    <textarea id='txtTrainingNeeds' name='txtTrainingNeeds' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ongoing Development Areas:</span>
                    <textarea id='txtOngoingDevelopmentAreas' name='txtOngoingDevelopmentAreas' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Required Frequency of Supervision:</span>
                    <textarea id='txtRequiredFrequency' name='txtRequiredFrequency' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Supervisor's Notes / Supervision Summary:</span>
                    <textarea id='txtSupervisorNotes' name='txtSupervisorNotes' className='add-only'></textarea>
                </p>
            </div>
        </form>

    )
}   